import {
  Boxes,
  Building2,
  Car,
  CalendarDays,
  CreditCard,
  FileText,
  LayoutDashboard,
  PhoneCall,
  Settings,
  Users,
  WalletCards,
  type LucideIcon,
} from 'lucide-react';

// Mirrors AdminDashboard's own tab icons (Drivers -> Users, Fleet -> Car,
// etc.) so a module reads as the same feature across every superadmin
// screen (Tenants & Modules, Pricing) as it does once a tenant's admin
// actually opens it -- shared here rather than duplicated per screen so
// they can't quietly drift apart.
export const MODULE_ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  drivers: Users,
  roster: CalendarDays,
  fleet: Car,
  payroll: WalletCards,
  crm: Building2,
  ivr: PhoneCall,
  ecards: CreditCard,
  settings: Settings,
  reports: FileText,
};

export const moduleIcon = (moduleKey: string): LucideIcon => MODULE_ICONS[moduleKey] ?? Boxes;
